import { Injectable } from '@angular/core'
import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '../../../environments/environment'
import { GtmReportAuthService } from '../gtm-report-auth/gtm-report-auth.service'
import { buildReport, GtmReport } from './gtm-report'

export class GtmSessionExpired extends Error {}

// Dados do GTM via back: o servidor consulta a Tag Manager API com a conta de
// serviço do .env e devolve a versão publicada do container
@Injectable({
	providedIn: 'root',
})
export class GtmApiService {
	private http: HttpClient

	constructor(handler: HttpBackend, private auth: GtmReportAuthService) {
		// Cliente sem interceptors: o AuthInterceptorService trocaria o
		// Authorization pelo token de login do site
		this.http = new HttpClient(handler)
	}

	async getReport(): Promise<GtmReport> {
		try {
			const response = await firstValueFrom(
				this.http.get<{ fetched_at: string; live_version: any }>(`${environment.gtmReport.api}/gtm-report/`, {
					headers: { Authorization: `Bearer ${this.auth.getToken()}` },
				})
			)
			return buildReport(response.live_version, new Date(response.fetched_at))
		} catch (error) {
			if (error instanceof HttpErrorResponse && error.status === 403) {
				this.auth.logout()
				throw new GtmSessionExpired(error.error?.message || 'Sessão do relatório expirada.')
			}
			const message = error instanceof HttpErrorResponse ? error.error?.message : ''
			throw new Error(message || 'Não foi possível carregar os dados do GTM.')
		}
	}
}
